/* global $ */
/* eslint-disable */

import getOptionsFromPrefix from '../helpers/getOptionsFromPrefix';

function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"); // eslint-disable-line
}

const PartsSelector = {
  /**
   * Instantiate parts selector
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {void}
   */
  create(node, props) {
    this.node = node;

    // Get the options from the data attributes
    this.options = getOptionsFromPrefix(props, 'partsSelector');

    // Save HTML template
    this.template = $(this.node).find('.js-parts-row-template').html();

    // Add new row
    $(this.node).on('click', '.js-parts-add', () => {
      this.addRow();
      this.renumber();
    });

    // Remove row
    $(this.node).on('click', '.js-parts-remove', (e) => {
      this.removeRow($(e.target).parents('.js-parts-row'));
      this.renumber();
    });
  },

  /**
   * Add new row by appending the template to the body
   * @return {void}
   */
  addRow() {
    $(this.node).find('.js-parts-body').append(this.template);
  },

  /**
   * Remove row
   * @param {Object} $row
   * @return {void}
   */
  removeRow($row) {
    $row.remove();
  },

  /**
   * Renumber the part rows
   * @return {void}
   */
  renumber() {
    const $rows = $(this.node).find('.js-parts-row');

    // Loop through every row
    $rows.toArray().forEach((row, i) => {
      // Get all elements starting with a general name
      const $input = $(row).find(`[name^="${this.options.name}"]`);

      // Loop through every input element
      $input.toArray().forEach((input) => {
        // Get the field name
        const { name } = input;

        // Regex to replace the general name
        const regex = new RegExp(escapeRegExp(this.options.name));

        // Remove the general name and the index
        const inputName = name
          .replace(regex, '')
          .replace(/^\[\d+]/, '');

        // Apply the general name with a new index
        input.name = `${this.options.name}[${i}]${inputName}`;
      });
    });
  },
};

export default PartsSelector;
